import React, { useEffect, useState } from 'react';
import {
  Box, TextField, Grid,
  Button, CircularProgress, Snackbar, Alert,
  Select, MenuItem
} from "@mui/material";
import { Helmet } from 'react-helmet-async';
import MuiAlert from '@mui/material/Alert';

import enIN from 'date-fns/locale/en-IN';

import { format } from 'date-fns';

import { authenticationService } from "src/services";
import { get, post } from "src/services/httpClient.service";
import { useSnackbar } from 'src/components/snackbar/useSnackbar';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

const AddPackage = (props) => {
  const { showSnackbar } = useSnackbar();
  const { vendorId, franchiseId } = authenticationService.getVendorFranchiseIds()

  const appIntegrations = localStorage.getItem('appIntegrations');
  const appIntegrationsList = appIntegrations ? JSON.parse(appIntegrations) : [];
  const [broadcasters, setBroadcasters] = useState([]);

  const [packages, setPackages] = useState([]);

  
  
  const [formValues, setFormValues] = useState({
      packageId: '', 
      planName: '',
      planAmount: '',   
      broadcasterId: "",
      broadcasterName: "",
      biMonthlyAmount: '',   
      quarterlyAmount: '',   
      halfYearlyAmount: '',  
      ncfCharges: '',
      annualAmount: '', 
      category: '', // Keep this if your API expects it, or remove it
      description: '', 
      details: '', 
      packageType: 'PACKAGE',
      subPackageIds: [],
      subPackageNames: [],
      status: 'ACTIVE', 
      vendorId: vendorId, 
      franchiseId: franchiseId,
      appType: '',
      planId: '',
      defaultPackage: false,
      isRefundable: false,
      isTaxIncluded: true,
    });

  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  const [appSubscriptionPlans, setAppSubscriptionPlans] = useState([])

  // Validation states
  const [errors, setErrors] = useState({
      planName: false, 
      planAmount: false,
      category: false,
      planId: false,
     
    });

  const handleChange = (e) => {
    setFormValues({ ...formValues, [e.target.id]: e.target.value });
  };

  const handleStatusChange = (e) => {
    setFormValues({ ...formValues, status: e.target.value });
  };

  /* const handleCheckboxChange = (e) => {
    setFormValues({
      ...formValues,
      defaultPackage: e.target.checked
    });
  };
 */

  const fetchPackages = async () => {
  try {
    const response = await get(
      `${process.env.REACT_APP_BASE_API_URL}${process.env.REACT_APP_PACKAGE}/vendor/${vendorId}/getAllPackagesByVendor`
    );

    const responseData = response?.data || [];

    const filteredPackages = responseData.filter(
      (pkg) => pkg.packageType !== 'A-LA-CARTE' && pkg.packageType !== 'BOUQUET'
    );

    setPackages(filteredPackages);
  } catch (error) {
    console.error("Error fetching packages:", error);
  }
};

const handleCheckboxChange = (e) => {
  const { name, checked } = e.target;

  setFormValues((prev) => ({
    ...prev,
    [name]: checked,
  }));
};
  const fetchBroadcasters = async () => {
    try {
      const response = await get(
        `${process.env.REACT_APP_BASE_API_URL}${process.env.REACT_APP_BROADCASTER}/${vendorId}`
      );

      console.log("Full response:", response);

      setBroadcasters(response || []);
    } catch (error) {
      console.error("Failed to fetch broadcasters:", error);
    }
  };

  useEffect(() => {
    fetchBroadcasters();
    fetchPackages();
  }, []);

  const handlePackageTypeChange = (e) => {
    setFormValues({ ...formValues, packageType: e.target.value });
  };

  

  const handleAppTypeChange = (e) => {
    const appType = e.target.value;
    setAppSubscriptionPlans([]);
    setFormValues({
      ...formValues,
      appType: appType,
      planId: ""
    });
    appPlansList(appType);
  };

  const appPlansList = async (appType) => {
    try {
      setLoading(true)

      let response = null;
      if(appType === "WATCHO") {
        response = await post(`${process.env.REACT_APP_BASE_API_URL}/api/watcho/vendor/${vendorId}/plans`);
        const plans = response?.Result || [];
        const appPlans = plans.map((plan, index) => ({
          planId: plan.SubscriptionPlanID,
          planName: plan.SubscriptionPlanName,
          planPrice: plan.SubscriptionPrice
        }))
        setAppSubscriptionPlans(appPlans)
      }
    } catch (err) {
      console.log('err', err)
      //showSnackbar('Failed to load plans', 'error')
    } finally {
      setLoading(false)
    }
  }

  const handleClose = () => {
    props.handleClose();
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const validateForm = () => {
    let formIsValid = true;
    const newErrors = {};

    if (!formValues.planName) {
      newErrors.planName = true;
      formIsValid = false;
    }

   

    if (formValues.planAmount === "" || isNaN(formValues.planAmount)) {
      newErrors.planAmount = true;
      formIsValid = false;
    }

    // Removed category validation

    // PlanId mandatory if appType selected
    if (formValues.appType && !formValues.planId) {
      newErrors.planId = true;
      formIsValid = false;
    }

    setErrors(newErrors);
    return formIsValid;
  };

  const onSubmit = async () => {
    if (!validateForm()) {
      setSnackbarSeverity('error');
      setSnackbarMessage('Please fill all fields correctly.');
      setSnackbarOpen(true);
      return;
    }

    const payload = {
      ...formValues,
      ncfCharges: Number(formValues.ncfCharges || 0),
      planAmount: Number(formValues.planAmount || 0),
      biMonthlyAmount: Number(formValues.biMonthlyAmount || 0),
      quarterlyAmount: Number(formValues.quarterlyAmount || 0),
      halfYearlyAmount: Number(formValues.halfYearlyAmount || 0),
      annualAmount: Number(formValues.annualAmount || 0),
    }

    setLoading(true);
    try {
      const response = await addPackage(payload);
      setLoading(false);

      if (response && response.id > 0) {
        setSnackbarSeverity('success');
        setSnackbarMessage('Package created successfully.');
        setSnackbarOpen(true);
       
       
      }
    } catch (error) {
      console.error('Error creating package:', error);
    }finally {
    setLoading(false); // ✅ STOP LOADER AFTER API RESPONSE
  }
  };

  async function addPackage(data) {
    
    try {
      const response = await post(`${process.env.REACT_APP_BASE_API_URL}${process.env.REACT_APP_PACKAGE}`, data);
      const responseData = response;
      //showSnackbar( 'Package Added Successfully', 'success')
      props.fetchPackageData();
      props.handleClose();
      return responseData;
    } catch (error) {
      console.log('check1', error?.response?.data)
      if (error?.response?.data != undefined && error?.response?.data != "") {
        //showSnackbar(error.response.data, 'error')
      } else {
        //showSnackbar('Create Package Failed', 'error')
      }
    }
  }

  return (
    <>
      <Helmet>
        <title>Add Package</title>
      </Helmet>
      <Grid container spacing={2} sx={{ mt: 1 }}>

        <Grid item xs={12} md={6}>
          <TextField
            required
            id="planName"
            value={formValues.planName}
            label="Plan Name"
            fullWidth
            onChange={handleChange}
            error={errors.planName}
            helperText={errors.planName ? 'Plan name is required.' : ''}
          />
        </Grid>

        




       {/*  <Grid item xs={12} md={6}>
          <TextField
            required
            id="planAmount"
            value={formValues.planAmount}
            label="Monthly Plan (1 Month)"
            fullWidth
            onChange={handleChange}
            error={errors.planAmount}
            helperText={errors.planAmount ? 'Please enter a valid amount.' : ''}
          />
        </Grid> */}

        <Grid item xs={12} md={6}>
  <TextField
    required
    id="planAmount"
    value={formValues.planAmount}
    label="1 Month Plan"
    type="number"
    fullWidth
    onChange={handleChange}
    error={errors.planAmount}
    helperText={errors.planAmount ? 'Please enter a valid amount.' : ''}
    inputProps={{ min: 0 }}
  />
</Grid>

<Grid item xs={12} md={6}>
  <TextField
    id="biMonthlyAmount"
    value={formValues.biMonthlyAmount}
    label="2 Months Plan"
    type="number"
    fullWidth
    onChange={handleChange}
    inputProps={{ min: 0 }}
  />
</Grid>

<Grid item xs={12} md={6}>
  <TextField
    id="quarterlyAmount"
    value={formValues.quarterlyAmount}
    label="3 Months Plan"
    type="number"
    fullWidth
    onChange={handleChange}
    inputProps={{ min: 0 }}
  />
</Grid>

<Grid item xs={12} md={6}>
  <TextField
    id="halfYearlyAmount"
    value={formValues.halfYearlyAmount}
    label="6 Months Plan"
    type="number"
    fullWidth
    onChange={handleChange}
    inputProps={{ min: 0 }}
  />
</Grid>

<Grid item xs={12} md={6}>
  <TextField
    id="annualAmount"
    value={formValues.annualAmount}
    label="12 Months Plan"
    type="number"
    fullWidth
    onChange={handleChange}
    inputProps={{ min: 0 }}
  />
</Grid>

        {/* Category dropdown removed */}

        <Grid item xs={12} md={6}>
          <Select
            id="packageType"
            value={formValues.packageType}
            onChange={handlePackageTypeChange}
            displayEmpty
            fullWidth
            renderValue={(selected) => (selected ? selected : 'Select Package Type')}
          >
            <MenuItem value="">Package Type</MenuItem>
            <MenuItem value="BASIC">BASIC</MenuItem>
            <MenuItem value="PACKAGE">PACKAGE</MenuItem>
            <MenuItem value="BOUQUET">BOUQUET</MenuItem>
          </Select>
        </Grid>

        {formValues?.packageType === 'BOUQUET' && <Grid item xs={12} md={6}>
  <Select
    multiple
    fullWidth
    displayEmpty
    value={formValues.subPackageIds}
    onChange={(e) => {
  const selectedIds = e.target.value;

  const selectedNames = packages
    .filter((pkg) => selectedIds.includes(pkg.id))
    .map((pkg) => pkg.planName);

  setFormValues({
    ...formValues,
    subPackageIds: selectedIds,
    subPackageNames: selectedNames,
  });
}}
    renderValue={(selected) => {
      if (!selected || selected.length === 0) {
        return "Select Packages";
      }

      return packages
        .filter((pkg) => selected.includes(pkg.id))
        .map((pkg) => pkg.planName)
        .join(", ");
    }}
  >
    <MenuItem value="" disabled>
      Select Packages
    </MenuItem>

    {packages.map((pkg) => (
      <MenuItem key={pkg.id} value={pkg.id}>
        {pkg.planName}
      </MenuItem>
    ))}
  </Select>
</Grid>}

        {appIntegrationsList.length > 0 && (
          <Grid item xs={12} md={6}>
            <Select
              id="appType"
              value={formValues.appType}
              onChange={handleAppTypeChange}
              displayEmpty
              fullWidth
              renderValue={(selected) => (selected ? selected : 'Select App Type')}
              disabled={appIntegrationsList.length === 0}
            >
              <MenuItem value="">App Type</MenuItem>

              {appIntegrationsList.map((app) => (
                <MenuItem key={app} value={app}>
                  {app}
                </MenuItem>
              ))}
            </Select>
          </Grid>
        )}

        {appIntegrationsList.length > 0 && (
          <Grid item xs={12} md={6}>
            <Select
              id="planId"
              value={formValues.planId}
              onChange={(e) =>
                setFormValues({ ...formValues, planId: e.target.value })
              }
              displayEmpty
              fullWidth
              error={errors.planId}
              renderValue={(selected) =>
                selected
                  ? appSubscriptionPlans.find(p => p.planId === selected)?.planName
                  : "Select Subscription Plan"
              }
              disabled={!formValues.appType}
            >
              <MenuItem value="">Select Subscription Plan</MenuItem>

              {appSubscriptionPlans.map((plan) => (
                <MenuItem key={plan.planId} value={plan.planId}>
                  {plan.planName} - ₹{plan.planPrice}
                </MenuItem>
              ))}
            </Select>
          </Grid>
        )}

        <Grid item xs={12} md={6}>
          <TextField
            id="ncfCharges"
            label="NCF Charges"
            type="number"
            fullWidth
            value={formValues.ncfCharges}
            onChange={handleChange}
            inputProps={{ min: 0 }}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <Select
            fullWidth
            value={formValues.broadcasterId}
            displayEmpty
            onChange={(e) => {
              const selected = broadcasters.find(
                (item) => item.id === e.target.value
              );

              setFormValues({
                ...formValues,
                broadcasterId: selected?.id || "",
                broadcasterName: selected?.name || "",
              });
            }}
            renderValue={(selected) =>
              selected
                ? broadcasters.find((b) => b.id === selected)?.name
                : "Select Broadcaster"
            }
          >
            <MenuItem value="">Select Broadcaster</MenuItem>

            {broadcasters.map((item) => (
              <MenuItem key={item.id} value={item.id}>
                {item.name}
              </MenuItem>
            ))}
          </Select>
        </Grid>

        <Grid item xs={12}>
          <TextField
            required
            id="description"
            value={formValues.description}
            label="Description"
            fullWidth
            onChange={handleChange}
            error={errors.description}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <FormControlLabel
  control={
    <Checkbox
      name="defaultPackage"
      checked={formValues.defaultPackage}
      onChange={handleCheckboxChange}
    />
  }
  label="Default Package"
/>
        </Grid>

        <Grid item xs={12} md={6}>
  <FormControlLabel
    control={
      <Checkbox
        name="isRefundable"
        checked={formValues.isRefundable}
        onChange={handleCheckboxChange}
      />
    }
    label="Refundable"
  />
</Grid>

<Grid item xs={12} md={6}>
  <FormControlLabel
    control={
      <Checkbox
        name="isTaxIncluded"
        checked={formValues.isTaxIncluded}
        onChange={handleCheckboxChange}
      />
    }
    label="Tax Included"
  />
</Grid>

      </Grid>
      <Box sx={{ float: "right", paddingBottom: "20px", paddingTop: "15px" }}>
        <Button onClick={onSubmit} variant="contained" sx={{ mt: 1, mr: 2 }} disabled={loading}>
          {loading ? <CircularProgress size={24} /> : 'Add'}
        </Button>
        <Button sx={{ marginInline: "8px" }} onClick={handleClose} variant="contained" disabled={loading}>
          Cancel
        </Button>
      </Box>
      <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
        <MuiAlert elevation={6} variant="filled" severity={snackbarSeverity} onClose={handleSnackbarClose}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
};

export default AddPackage;